<template>
  <div class="campaigns">
    <breadcrumbs :breadcrumbsData="breadcrumbsData" #icon>
      <svg class="icon" aria-hidden="true">
        <use xlink:href="#icon-a-PaidPlacement" style="color: #fff;"></use>
      </svg>
    </breadcrumbs>

    <div class="right-top">
      <artmisads-select-button @click="toInvoicePdf" v-if="current >= 1&&campaignInfo?.status !== 'declined'&&
campaignInfo?.status !== 'cancelled'&&
campaignInfo?.status !== 'canceled'" class="invoice">
              <svg class="icon icon-daochu1" style="padding-left: 4px;" aria-hidden="true">
                <use xlink:href="#icon-daochu1"></use>
              </svg>
              {{ st('finance.downloadInvoice') }}
      </artmisads-select-button>
      <div class="right-top-left" v-if="campaignInfo?.paymentCountdown && current == 1">
        <svg-icon name="dengdai" class="daochu1" />
        <span>{{ st('campaignsDetail.paymentCountdownLabel') }}  </span>
        <div class="number-box" :class="{ 'urgent': isUrgent }" style="margin-left: 12px;height: 22px;">
          {{ paymentCountdown?.[0] }}
        </div>
        <div style="padding: 0 2px;">:</div>
        <div class="number-box" :class="{ 'urgent': isUrgent }" style="height: 22px;width: 22px;padding: 0;text-align: center;">
          {{ paymentCountdown?.[1] }}
        </div>
        <div style="padding: 0 2px;">:</div>
        <div class="number-box" :class="{ 'urgent': isUrgent }" style="height: 22px;width: 22px;padding: 0;text-align: center;">
          {{ paymentCountdown?.[2] }}
        </div>
      </div>

      <div class="right-top-right-box" v-if="current == 0">
        <artmisads-button :isSquare="true" type="primary" class="right-top-right" @click="suspend">
          {{ st('campaigns.btnSuspend') }}
        </artmisads-button>
      </div>
      <div class="right-top-right-box" v-if="current == 1">
        <artmisads-button :isSquare="true" type="primary" class="right-top-right" @click="payCampaign">
          {{ st('campaigns.btnPay') }}
        </artmisads-button>
      </div>
      <div class="right-top-right-box" v-if="current == 3">
        <artmisads-button :isSquare="true" type="primary" class="right-top-right" @click="confirm">
          {{ st('campaignsDetail.btnConfirm') }}
        </artmisads-button>
      </div>
    </div>
    <a-spin :spinning="loading">
      <div class="content" :style="{backgroundColor:campaignInfo?.status !== 'cancelled'&& campaignInfo?.status !== 'completed' && campaignInfo?.status !== 'confirmed'&&campaignInfo?.status !== 'declined'&&campaignInfo?.status !== 'suspended'&&campaignInfo?.status !== 'canceled'? 'transparent' : '#fff'}">
        <div class="steps-wrapper" >
          <a-steps :items="stepsItems" class="steps-wrapper-steps" :current="current"
           v-if="campaignInfo?.status !== 'cancelled'&& campaignInfo?.status !== 'completed' && campaignInfo?.status !== 'confirmed'&&campaignInfo?.status !== 'declined'&&campaignInfo?.status !== 'suspended'&&campaignInfo?.status !== 'canceled'"></a-steps> 
          <div v-else class="steps-wrapper-text">
            <div class="top">
           
              <svg-icon 
              :name="campaignInfo?.status === 'cancelled'||campaignInfo?.status === 'declined'||campaignInfo?.status === 'suspended' ? 'a-error-tianchong5' : 'success-tianchong'" 
              :class="campaignInfo?.status === 'cancelled'||campaignInfo?.status === 'declined'||campaignInfo?.status === 'suspended' ? 'icon-top-error' : 'icon-top-success'" />
              <span class="text-top">{{ cooperationHeadline(campaignInfo?.status) }}</span>
            </div>
            <!-- <div class="bottom">
              {{  campaignInfo.status === 'canceled' ? 'Auto-canceled (unpaid)' : 'Funds transferred' }}
            </div> -->
          </div>
        </div>
      </div>
      <div class="content marigin-top-16" v-if="!showLastUi">
        <div class="content-wrapper-top">
          <div class="content-wrapper-top-title">
            {{ st('campaignsDetail.sectionCampaignInfo') }}
          </div>
        </div>
        <div class="content-wrapper-bottom">
          <div class="content-wrapper-bottom-top">
            <div class="item">
              <div class="item-title">
                {{ st('campaignsDetail.labelCampaignStatus') }}
              </div>
              <div class="item-content">
                <div v-if="campaignInfo?.status === 'completed'">
                <PlacementStatus :type="statusInfo[campaignInfo?.status]?.type || '--'"
                :text="st('campaigns.statusPublished')" />
                </div>
              <div v-else>
                <PlacementStatus :type="statusInfo[campaignInfo?.status]?.type || '--'"
                :text="campaignStatusDisplay(campaignInfo?.status)" />
              </div>
                <!-- <PlacementStatus :type="statusInfo[campaignInfo.status]?.type || '--'"
                  :text="statusInfo[campaignInfo.status]?.text || '--'" /> -->
              </div>
            </div>
            <div class="item">
                <div class="item-title">
                  {{ st('placement.labelPublisherName') }}
                </div>
                <div class="content-linkType" style="cursor: pointer;"  @click="goToPublisherDetail(publisherInfo)">
                  <!-- <img 
                    :src="publisherInfo.publisherHeadImageUrl" alt="" class="icon"> -->
                    <LogoImage :maxWidth="'95%'" backgroundColor="#fff" :borderRadius="2"  :logoUrl="publisherInfo?.publisherHeadImageUrl" :brandName="publisherInfo?.publisherName" :width="20"
                    :height="20" :fontSize="4" />
                  <span class="content-linkType-text" :class="publisherInfo?.publisherName ? '' : 'font-gray'">{{ publisherInfo?.publisherName ||'--' }}</span>
                  <svg-icon name="jiantou-you-cu" style="width: 12px;height: 12px;" />
                </div>
              </div>
           
            <div class="item">
              <div class="item-title">
                {{ st('campaignsDetail.labelApplyDate') }}
              </div>
              <div class="item-content">
                {{ setTime(campaignInfo?.applyDate) }}
              </div>
            </div>
            <div class="item">
              <div class="item-title">
                {{ st('campaignsDetail.labelResources') }}
              </div>
              <div class="item-content">
                <div class="resources-content">
                  <div v-if="campaignInfo?.resourceFiles?.length > 0" class="resources-content-item">
                    <div class="resources-item" v-for="item in campaignInfo?.resourceFiles" :key="item?.url">
                      <div v-if="isImage(item?.originalFileName)" class="item-content-image">
                        <a-image :src="item?.url" alt=""  :placeholder="true" />
                      </div>
                      <div v-else>
                        {{ item?.originalFileName }}
                      </div>
                    </div>
                   
                  </div>
                  <div v-else class="font-gray">
                    --
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div class="content-wrapper-bottom-top" style="margin-top: 23px;">
            <div class="item">
              <div class="item-title">
                {{ st('campaignsDetail.labelApplicationDescription') }}
              </div>
              <div class="item-content" :class="campaignInfo?.description ? '' : 'font-gray'">
                {{ campaignInfo?.description ||'--' }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="contentFlexOne">
        <div class="content" :style="{width:campaignInfo?.status === 'cancelled'?'100%':'35%',minWidth:campaignInfo?.status === 'cancelled'?'':'350px'}">
          <div class="content-wrapper-top">
            <div class="content-wrapper-top-title">
              {{ st('campaignsDetail.sectionCampaignInfo') }}
            </div>
          </div>
          <div class="content-wrapper-bottom">
            <div class="content-wrapper-bottom-top ">
              <div class="item">
                <div class="item-title">
                  {{ st('campaignsDetail.labelCampaignStatus') }}
                </div>
                <div class="item-content">
                  <div v-if="campaignInfo?.status === 'completed'">
                <PlacementStatus :type="statusInfo[campaignInfo?.status]?.type || '--'"
                :text="st('campaigns.statusPublished')" />
              </div>
              <div v-else>
                <PlacementStatus :type="statusInfo[campaignInfo?.status]?.type || '--'"
                :text="campaignStatusDisplay(campaignInfo?.status)" />
              </div>
                 
                </div>
              </div>
              <div class="item">
                <div class="item-title">
                  {{ st('placement.labelPublisherName') }}
                </div>
                <div class="content-linkType" style="cursor: pointer;"  @click="goToPublisherDetail(publisherInfo)">
                  <!-- <img 
                    :src="publisherInfo.publisherHeadImageUrl" alt="" class="icon"> -->
                    <LogoImage backgroundColor="#fff" :borderRadius="2" :maxWidth="'95%'" :logoUrl="publisherInfo?.publisherHeadImageUrl" :brandName="publisherInfo?.publisherName" :width="20"
                    :height="20" :fontSize="4" />
                  <span class="content-linkType-text" :class="publisherInfo?.publisherName ? '' : 'font-gray'">{{ publisherInfo?.publisherName ||'--' }}</span>
                  <svg-icon name="jiantou-you-cu" style="width: 12px;height: 12px;" />
                </div>
              </div>

            </div>
            <div class="content-wrapper-bottom-top " style="margin-top: 23px;">
              <div class="item">
                <div class="item-title">
                  {{ st('campaignsDetail.labelApplyDate') }}
                </div>
                <div class="item-content">
                  {{ setTime(campaignInfo?.applyDate) }}
                </div>
              </div>
            </div>
            <div class="content-wrapper-bottom-top " style="margin-top: 23px;">
              <div class="item">
                <div class="item-title">
                  {{ st('campaignsDetail.labelApplicationDescription') }}
                </div>
                <div class="item-content">
                  {{ campaignInfo?.description ||'--' }}
                </div>
              </div>
            </div>
            <div class="content-wrapper-bottom-top " style="margin-top: 23px;">
              <div class="item">
                <div class="item-title">
                  {{ st('campaignsDetail.labelResources') }}
                </div>
                <div class="item-content">
                  <div class="resources-content">
                    <div v-if="campaignInfo?.resourceFiles?.length > 0" class="resources-content-item">
                      <div class="resources-item" v-for="item in campaignInfo?.resourceFiles" :key="item?.url">
                        <div v-if="isImage(item?.originalFileName)" class="item-content-image">
                          <a-image :src="item?.url" alt=""  :placeholder="true" />
                        </div>
                        <div v-else>
                          {{ item?.originalFileName }}
                        </div>
                      </div>

                    </div>
                    <div v-else class="font-gray">
                      --
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="content" style="width:65%" v-if="campaignInfo?.status !== 'cancelled'">
          <div class="content-wrapper-top">
            <div class="content-wrapper-top-title content-wrapper-top-title-button">
              {{ st('campaignsDetail.sectionCompletionInfo') }}
             
            </div>
          </div>
          <div class="content-wrapper-bottom">
            <div class="content-wrapper-bottom-top ">
              <div class="item">
                <div class="item-title">
                  {{ st('campaignsDetail.labelPublishDate') }}
                </div>
                <div class="item-content">
                  {{ setTime(campaignCompletionInfo?.publishDate) }}
                </div>
              </div>
              <div class="item">
                <div class="item-title">
                  {{ st('campaignsDetail.labelEndDate') }}
                </div>
                <div class="item-content">
                  {{ setTime(campaignCompletionInfo?.endDate) }}
                </div>
              </div>
            </div>
            <div class="content-wrapper-bottom-top " style="margin-top: 23px;">
              <div class="item">
                <div class="item-title">
                  {{ st('campaignsDetail.labelPublishedUrl') }}
                </div>
                <div class="item-content">
                  <a style="text-decoration: underline;" @click.prevent="goToPublishedUrl" v-if="campaignCompletionInfo?.publishUrl" :href="campaignCompletionInfo?.publishUrl" target="_blank">{{ campaignCompletionInfo?.publishUrl
                  }}
                  </a>
                  <span v-else class="font-gray">--</span>
                </div>
              </div>
            </div>
            <div class="content-wrapper-bottom-top" style="margin-top: 23px;gap: 16px;">
              <div class="content-wrapper-bottom-top-item">
                <div class="content-wrapper-bottom-top-item-left">
                  <div class="content-wrapper-bottom-top-item-title">
                    {{ st('campaignsDetail.labelClicks') }}
                  </div>
                  <div :class="campaignCompletionInfo?.clicks ? 'content-wrapper-bottom-top-item-content' : 'font-gray content-wrapper-bottom-top-item-content'" >
                    {{formatNumber(campaignCompletionInfo?.clicks)  ||'--' }}
                  </div>
                </div>
                <div class="content-wrapper-bottom-top-item-right">
                  <div class="icon-box">
                    <svg-icon name="jian-dianji" class="icon"/>
                  </div>
                </div>
              </div>
              <div class="content-wrapper-bottom-top-item">
                <div class="content-wrapper-bottom-top-item-left">
                  <div class="content-wrapper-bottom-top-item-title">
                    {{ st('campaignsDetail.labelImpressions') }}
                  </div>
                  <div :class="campaignCompletionInfo?.impressions ? 'content-wrapper-bottom-top-item-content' : 'font-gray content-wrapper-bottom-top-item-content'" >
                    {{formatNumber(campaignCompletionInfo?.impressions)||'--' }}
                  </div>
                </div>
                <div class="content-wrapper-bottom-top-item-right">
                  <div class="icon-box" style="background:#2CAFFF;">
                    <svg-icon name="yanjing-kai1" class="icon" />
                  </div>
                </div>
              </div>
            </div>
            <div class="content-wrapper-bottom-top" style="margin-top: 23px;">
              <div class="screentshots">
                <div class="screentshots-title">
                  {{ st('campaignsDetail.sectionScreenshots') }}
                </div>
                <div class="screentshots-content">
                  <div class="image-box" v-for="item in campaignCompletionInfo?.completionScreenshots" :key="item?.url">
                    <a-image  :src="item?.url" alt=""  :placeholder="true" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div class="content marigin-top-16">
        <div class="content-wrapper-top">
          <div class="content-wrapper-top-title content-wrapper-top-title-button">
            {{ st('campaignsDetail.sectionCampaignAsins') }}
           
          </div>
        </div>
        <div class="content-wrapper-bottom">
          <artmisads-table :loading="loading" :columns="columns" :data-source="dataSource" :pagination="null"
            :change="onChangePage">
            <template #bodyCell="{ column, text, index, record }">
              <template v-if="column.key === 'Product'">
                <div class="product-item">
                  <img :src='record?.productImageUrl' />
                  <div class="text">
                    <p class="title" :class="record?.productName ? '' : 'font-gray'">{{ record?.productName ||'--' }}</p>
                  </div>
                </div>
              </template>
              <template v-if="column.key === 'price'">
                <span>{{ AMAZON_CURRENCY_MAPPER[record?.marketplace] }}{{ record?.price }}</span>
                <span class="text-gray" v-if="record?.originalPrice > record?.price">{{
                  AMAZON_CURRENCY_MAPPER[record?.marketplace] }}{{ record?.price }}</span>
              </template>
              <template v-if="column.key === 'commission'">
                <a-tag color="#835CF2" class="commission-tag">{{ record?.commission }}</a-tag>
              </template>
              <!-- <template v-if="column.name === 'storeFrontLink'">
                <a v-if="record?.storeFrontLink" style="text-decoration: underline;" target="_blank" @click="copyToClipboardText(record?.storeFrontLink)">{{ record?.storeFrontLink }}</a>
                <div v-else class="font-gray">--</div>
              </template>
              <template v-if="column.name === 'productShortLink'">
                <a v-if="record?.productShortLink" style="text-decoration: underline;" target="_blank" @click="copyToClipboardText(record?.productShortLink)">{{ record?.productShortLink }}</a>
                <div v-else class="font-gray">--</div>
              </template> -->
            </template>
          </artmisads-table>
        </div>
      </div>
      <div class="contentFlex marigin-top-16">
        <div class="content">
          <div class="content-wrapper-top">
            <div class="content-wrapper-top-title">
              {{ st('placement.sectionPlacementInfo') }}
            </div>
          </div>
          <div class="content-wrapper-bottom">
            <div class="content-wrapper-bottom-top">
              <div class="item">
                <div class="item-title">
                  {{ st('placement.labelPlacementName') }}
                </div>
                <div class="item-content text-one" :class="placementInfo?.placementName ? '' : 'font-gray'">
                  {{ placementInfo?.placementName ||'--' }}
                </div>
              </div>
            </div>
            <div class="content-wrapper-bottom-top" style="margin-top: 23px;">
             
              <div class="item">
                <div class="item-title">
                  {{ st('placement.labelDuration') }}
                </div>
                <div class="item-content" :class="placementInfo?.duration ? '' : 'font-gray'">
                  {{ placementInfo?.duration ||'--' }}
                </div>
              </div>
              <div class="item">
                <div class="item-title">
                  {{ st('placement.labelPrice') }}
                </div>
                <div class="item-content red-text">
                  {{ CURRENCY_DATA_MAPPER[placementInfo?.currency] }} {{ placementInfo?.price?.toFixed(2) }}
                </div>
              </div>
            </div>
            <div class="content-wrapper-bottom-top" style="margin-top: 23px;">
              <div class="item">
                <div class="item-title">
                  {{ st('placement.labelAvailableFrom') }}
                </div>
                <div class="item-content">
                  {{ placementInfo?.availableFrom ? setTime(placementInfo?.availableFrom) : '-' }}
                </div>
              </div>
              <div class="item">
                <div class="item-title">
                  {{ st('placement.labelLeadTime') }}
                </div>
                <div class="item-content" :class="placementInfo?.leadTime ? '' : 'font-gray'">
                  {{ placementInfo?.leadTime||'--' }}
                </div>
              </div>
              
            </div>
            <div class="content-wrapper-bottom-top" style="margin-top: 23px;">
              <div class="item">
                <div class="item-title">
                  {{ st('placement.labelPlacementDescription') }}
                </div>
                <div class="item-content" :class="placementInfo?.placementDescription ? '' : 'font-gray'">
                  {{ placementInfo?.placementDescription ||'--' }}
                </div>
              </div>
            </div>
            <div class="content-wrapper-bottom-top" style="margin-top: 23px;">
              <div class="item">
                <div class="item-title">
                  {{ st('placement.labelSpecs') }}
                </div>
                <div class="item-content" :class="placementAdvancedInfo?.specifications ? '' : 'font-gray'">
                  {{ placementAdvancedInfo?.specifications||'--' }} 
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="content">
          <div class="content-wrapper-top">
            <div class="content-wrapper-top-title">
              {{ st('placement.sectionAdvancedInfo') }}
            </div>
          </div>
          <div class="content-wrapper-bottom">
            <div class="content-wrapper-bottom-top">
              <div class="item">
                <div class="item-title">
                  {{ st('placement.labelAutoCancelPeriod') }}
                </div>
                <div class="item-content" :class="placementAdvancedInfo?.autoCancelPeriod ? '' : 'font-gray'">
                  {{ placementAdvancedInfo?.autoCancelPeriod ||'--' }}
                </div>
              </div>
              <div class="item">
                <div class="item-title">
                  {{ st('placement.labelAvailableLinkType') }}
                </div>
                <div class="content-linkType">
                  <img v-if="placementAdvancedInfo?.linkType === 'attribution'"
                    src="../../../../assets/images/img/AT@2x.png" alt="" class="icon">
                  <img v-else src="../../../../assets/images/img/AS@2x.png" alt="" class="icon">
                  <span class="content-linkType-text">{{ placementAdvancedInfo?.availableLinkType === 'attribution' ?
                    'Attribution' :
                    'Associate' }}</span>
                </div>
              </div>
            </div>
            <div class="content-wrapper-bottom-top" style="margin-top: 23px;">
              <div class="item">
                <div class="item-title">
                  {{ st('placement.labelMaxPromotableAsins') }}
                </div>
                <div class="item-content" :class="placementAdvancedInfo?.maxPromotableAsins ? '' : 'font-gray'">
                  {{ placementAdvancedInfo?.maxPromotableAsins ||'--'}}
                </div>
              </div>
              <div class="item">
                <div class="item-title">
                  {{ st('placement.labelAvailableResultsDisplay') }}
                </div>
                <div class="item-content">
                  {{setAvailableResultsDisplay(placementAdvancedInfo?.availableResultsDisplay)}}
                </div>
              </div>
            </div>
            <div class="content-wrapper-bottom-top" style="margin-top: 23px;">
              <div class="item">
                <div class="item-title">
                  {{ st('placement.labelExamples') }}
                </div>
                <div class="item-content">
                  <div v-for="item in placementAdvancedInfo?.exampleFiles" :key="item?.id">
                    <div v-if="isImage(item?.originalFileName)" class="item-content-image-one">
                      <a-image :src="item?.url" alt=""  :placeholder="true" />
                    </div>
                    <div v-else>
                      {{ item?.originalFileName }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </a-spin>
    <invoiceModal :setDetailData="setDetailData"  :payOrderList="payOrderList"
    v-if="showInvoiceModal" />
  </div>
</template>
<script setup>
import { ref, onMounted, onUnmounted, computed } from 'vue'
import breadcrumbs from '@/components/breadcrumbs.vue'
import { useRoute, useRouter } from 'vue-router'
import SvgIcon from '~/components/SvgIcon.vue'
import { sellerCampaignsApi } from '@/server'
import { AMAZON_CURRENCY_MAPPER, statusInfo } from '@/contants/common'
import PlacementStatus from '@/components/placementStatus.vue'
import { CURRENCY_DATA_MAPPER,COUNTRY_SITE_CODE_MAP } from '~/contants/common'
import { message } from 'ant-design-vue'
import invoiceModal from './components/invoiceModal.vue'
import LogoImage from '@/components/LogoImage.vue'
import {  formatNumber, setTime } from '~/utils'
import { Modal } from 'ant-design-vue'
import { useSellerI18n } from '@/composables/useSellerI18n'

const { st } = useSellerI18n()

function campaignStatusDisplay(status) {
  if (!status) return '--'
  const key = {
    pending: 'statusPending',
    pedding: 'statusPending',
    declined: 'statusDeclined',
    cancelled: 'statusCanceled',
    canceled: 'statusCanceled',
    accepted: 'statusAccepted',
    paid: 'statusInProgress',
    confirming: 'statusConfirming',
    confirmed: 'statusPublished',
    completed: 'statusPublished',
    suspended: 'statusSuspended',
  }[status]
  return key ? st(`campaigns.${key}`) : (statusInfo[status]?.text || status)
}

function cooperationHeadline(status) {
  if (status === 'completed') {
    return st('campaignsDetail.cooperationHasBeenFinished')
  }
  return st('campaignsDetail.cooperationHasBeenStatus', { status: campaignStatusDisplay(status) })
}

const showInvoiceModal = ref(false)
const payOrderList = ref(null)
const route = useRoute()
const router = useRouter()
const publisherInfo=ref({})
const showLastUi = computed(() => {
  return statusInfo[campaignInfo.value?.status]?.step >= 3
})
const setDetailData = (data, type, hasCompleteInfo = false, setShowNotice = false) => {
  showInvoiceModal.value = false

}
const  toInvoicePdf = () => {

  const { href } = router.resolve({ path: `/seller/campaigns-invoice-pdf/${campaignInfo.value?.id}` });
  window.open(href, '_blank');
}
const campaignId = ref(route?.params?.id)
const countryCode=ref('')
const open=ref(false)
const productId=ref([])
const breadcrumbsData = computed(() => ({
  title: st('campaignsDetail.pageTitle'),
  des: st('campaigns.pageDes'),
  color: '#80C026',
  links: [
    {
      name: st('common.home'),
      path: '/seller/dashboard',
    },
    {
      name: st('placement.breadcrumbPaidPlacements'),
      path: '/seller/Settings/paidPlacement/campaigns',
    },
    {
      name: st('campaignsDetail.pageTitle'),
      path: `/seller/Settings/paidPlacement/campaigns/${campaignId.value}`,
    },
  ],
}))
const current = ref(null)
const stepsItems = computed(() => [
  {
    title: st('campaignsDetail.stepPendingTitle'),
    description: st('campaignsDetail.stepPendingDesc'),
  },
  {
    title: st('campaignsDetail.stepAcceptedTitle'),
    description: st('campaignsDetail.stepAcceptedDesc'),
  },
  {
    title: st('campaignsDetail.stepInProgressTitle'),
    description: st('campaignsDetail.stepInProgressDesc'),
  },
  {
    title: st('campaignsDetail.stepConfirmingTitle'),
    description: st('campaignsDetail.stepConfirmingDesc'),
  },
  {
    title: st('campaignsDetail.stepPublishedTitle'),
    description: st('campaignsDetail.stepPublishedDesc'),
  },
])
const columns = computed(() => [
  {
    title: st('placement.applicationColProduct'),
    dataIndex: 'Product',
    key: 'Product',
  },
  {
    title: st('placement.applicationColAsin'),
    dataIndex: 'asin',
    key: 'asin',
  },
  {
    title: st('campaignsDetail.colMarketplace'),
    dataIndex: 'marketplace',
    key: 'marketplace',
  },
  {
    title: st('placement.applicationColPrice'),
    dataIndex: 'price',
    key: 'price',
  },
  {
    title: st('placement.applicationColCommission'),
    dataIndex: 'commission',
    key: 'commission',
  },
  // {
  //   title: 'storeFrontLink',
  //   dataIndex: 'storeFrontLink',
  //   name: 'storeFrontLink',
  // },
  // {
  //   title: 'productShortLink',
  //   dataIndex: 'productShortLink',
  //   name: 'productShortLink',
  // }
])
const dataSource = ref([])
const loading = ref(false)
const tableTotal = ref(0)

const goToPublisherDetail = (publisherInfo) => {
  // const data = {
  //   id: publisherInfo.publisherId,
  
  //   publicImage: publisherInfo.publisherHeadImageUrl,
  //   promotionCountries: item.promotionCountries,
  //   promotionMethods: item.promotionMethods,
  //   promotionProductCategories: item.promotionProductCategories,
  //   publicBio: item.publicBio,
  //   associateBrandCount: item.associateBrandCount,
  //   associateEnabled: item.associateEnabled,
  //   links: item.links
  // }
  // sessionStorage.setItem('publisherDetail', JSON.stringify(data))
  window.open(`/seller/publishers/${publisherInfo?.publisherId}`, '_blank')
  
}

const goToPublishedUrl=()=>{
  let url = campaignCompletionInfo.value?.publishUrl?.trim()
  if (!url) return
  // 若无协议或以 / 开头，规范为绝对外链，避免拼接项目域名
  // if (/^\/+/.test(url)) {
  //   url = url.replace(/^\/+/, '')
  // }
  if (!/^https?:\/\//i.test(url)) {
    url = `https://${url}`
  }
  window.open(url, '_blank', 'noopener')
}
const setAvailableResultsDisplay=(availableResultTypes)=>{
  if(availableResultTypes){
   return availableResultTypes?.replaceAll('\\\\','/')
  }
  else{
    return '--'
  }
}
const campaignInfo = ref({})
const placementInfo = ref({})
const placementAdvancedInfo = ref({})
const campaignCompletionInfo = ref({})
const paymentCountdown = ref([])
const countdownTimer = ref(null)
const isUrgent = ref(false)
const isImage = (url) => {
  if (!url) return
  return url?.includes('.jpg') || url?.includes('.jpeg') || url?.includes('.png') || url?.includes('.gif')
}
const setAvailableResultTypes = (availableResultTypes) => {
  if (Array.isArray(availableResultTypes)) {
    return availableResultTypes.join("/")
  }
}

const startCountdown = () => {
  if (countdownTimer.value) {
    clearInterval(countdownTimer.value)
  }

  countdownTimer.value = setInterval(() => {
    if (paymentCountdown.value?.length === 3) {
      let [hours, minutes, seconds] = paymentCountdown.value?.map(Number)

      if (seconds > 0) {
        seconds--
      } else if (minutes > 0) {
        minutes--
        seconds = 59
      } else if (hours > 0) {
        hours--
        minutes = 59
        seconds = 59
      } else {
        // 倒计时结束，重新请求数据
        clearInterval(countdownTimer.value)
        countdownTimer.value = null
        init()
        return
      }

      paymentCountdown.value = [
        hours.toString().padStart(2, '0'),
        minutes.toString().padStart(2, '0'),
        seconds.toString().padStart(2, '0')
      ]

      // 检查是否小于24小时
      isUrgent.value = hours < 24
    }
  }, 1000)
}
const init = () => {
  loading.value = true
  sellerCampaignsApi.getCampaignsDetail({ campaignId: campaignId.value }).then(res => {

    if (Array.isArray(res?.data?.campaignInfo?.asins)) {
      dataSource.value = res?.data?.campaignInfo?.asins
      tableTotal.value = res?.data?.campaignInfo?.asins?.length
    } else {
      dataSource.value = []
      tableTotal.value = 0
    }
    campaignInfo.value = res?.data?.campaignInfo
    
    if (campaignInfo.value?.paymentCountdown) {
      paymentCountdown.value = campaignInfo.value?.paymentCountdown?.split(':')
      // 初始化时检查是否小于24小时
      const [hours] = paymentCountdown.value?.map(Number)
      isUrgent.value = hours < 24
      startCountdown()
    }
    payOrderList.value={
      ...placementInfo,
      invoiceNo:res?.data?.campaignInfo?.invoiceNo
    }
    placementInfo.value = res?.data?.placementInfo
    publisherInfo.value = res?.data?.publisherInfo
    placementAdvancedInfo.value = res?.data?.placementAdvancedInfo
    campaignCompletionInfo.value = res?.data?.campaignCompletionInfo
    countryCode.value=COUNTRY_SITE_CODE_MAP[res?.data?.campaignInfo?.marketplace]
    productId.value=res?.data?.campaignInfo?.asins?.map(item=>item?.productId)
    if(res?.data?.campaignInfo?.status === 'declined'||
   res?.data?.campaignInfo?.status === 'suspended'||
   res?.data?.campaignInfo?.status === 'cancelled'
  
  ){
    current.value=99
    }
    else {
      current.value = statusInfo[res?.data?.campaignInfo?.status]?.step || 0
    }
  }).finally(() => {
    loading.value = false
  })
}
const downloadResource = () => {
  console.log('downloadResource')

}

const suspend = () => {
  Modal.confirm({
    title: st('campaigns.suspendConfirmTitle'),
    content: st('campaigns.suspendConfirmContent'),
    onOk: async () => {
      sellerCampaignsApi.suspendCampaign({ campaignId: campaignId.value }).then(res => {
        if (res.success) {
          message.success(st('campaigns.suspendSuccess'))
          init()
        } else {
          message.error(res.error)
        }
      })
    }
  })
}
const confirm = () => {
  Modal.confirm({
    title: st('campaigns.suspendConfirmTitle'),
    content: st('campaignsDetail.confirmModalContent'),
    onOk: async () => {
      sellerCampaignsApi.confirmCompletion({ campaignId: campaignId.value }).then(res => {
        if (res.success) {
          message.success(st('campaignsDetail.confirmSuccess'))
          init()
        } else {
          message.error(res.error)
        }
      })
    }
  })
}
const payCampaign = () => {
  console.log('payCampaign')
  showInvoiceModal.value = true
}
const completeModalRef = ref(null)

const handleComplete = (formData) => {
  init()
}
const onSaveCallback = (formData) => {
  open.value = false
  if(formData){
    init()
  }
}

onMounted(() => {
  campaignId.value = route?.params?.id
  init()
})

onUnmounted(() => {
  if (countdownTimer.value) {
    clearInterval(countdownTimer.value)
    countdownTimer.value = null
  }
})
</script>
<style scoped lang="less">
.invoice{
 display: flex;

}
.font-gray{
  color: #86909c;
}
:deep(.ant-steps-item-active .ant-steps-item-title){
  font-weight: 550 !important;
  color: #835cf2!important;
}
:deep(.ant-steps-item-active .ant-steps-item-description){
  color: #835cf2!important;
}
:deep(.ant-steps .ant-steps-item-process .ant-steps-item-icon){
  background: #835cf2!important;

}
:deep(.ant-steps .ant-steps-item-finish .ant-steps-item-icon){
 
  .anticon{
    color: #fff!important;
  }
  background: #835cf2!important;
  color: #fff!important;
}
:deep(.ant-steps-item-icon){
 background: #fff !important;
}
:deep(.ant-steps-item-description){
 font-size: 12px !important;
 color: rgba(0, 0, 0, 0.45) !important;
}
@media (max-width: 1150px) {
  :deep(.ant-steps-item-description){
    max-width: 100px !important;
  }
}
  .icon-daochu1{
    width: 20px;
    height: 20px;
    margin-right: 8px;
    align-self: center;
  }
 
/* 完全禁止 a-steps 鼠标事件（移入/点击） */
:deep(.steps-wrapper-steps) {
  pointer-events: none !important;
  cursor: default !important;
}

/* 禁用 Ant Image 默认的悬浮遮罩效果（本页内） */

.text-one{
  display: block;
}
.item-content{
  .item-content-image-one{
    width: 100px;
    height: 100px;
    border-radius: 8px;
    border: 1px solid #E5E5E5;
    overflow: hidden;
    background-color: #F1F0F5;
    display: flex;
    align-items: center;
    justify-content: center;
    :deep(img) {
     max-height: 100px;
       object-fit: contain;
    }
  }
}
/* 覆盖 .item-content 上的 display:flex，确保省略号生效 */
.item-content.text-one{
  display: block !important;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
/* 允许弹性子项在 flex 布局中收缩，否则省略号不会生效 */
.content-wrapper-bottom-top .item{
  min-width: 0;
}
.right-top-right-box {
  display: flex;
  gap: 20px;

}

.steps-wrapper-text{
  .icon-top-error{
  color: #EB4E3D;
  font-size: 24px;
}
.icon-top-success{
  color: #80C026;
  font-size: 24px;

}
  .top{
    display: flex;
    gap: 12px;
    align-items: center;
    .text-top{
      color: #1d2129;
 font-family: "Sora";
 font-size: 18px;
 font-style: normal;
 font-weight: 600;

    }
  }
  .bottom{
    color: #0f0629;
 font-family: "Sora";
 font-size: 13px;
 font-style: normal;
 font-weight: 400;
 margin-top: 10px;
 opacity: 0.5;
  }
}
.right-top {
  position: absolute;
  right: 15px;
  top: 40px;
  display: flex;
  gap: 20px;
  align-items: center;
  .right-top-left {
    display: flex;
    border-radius: 8px;
    background: #FFF;
    align-items: center;
    padding: 10px;

    .number-box {
      display: flex;
      color: #fff;
      padding: 0 2px;
      flex-direction: column;
      justify-content: center;
      line-height: 24px;
      min-width: 18px;
      min-height: 22px;
      border-radius: 4px;
      background: #0f0629b3;

      &.urgent {
        background: #EB4E3D;
      }
    }
  }
}

.icon-box {
  width: 22px;
  height: 22px;

  border-radius: 4px;
  opacity: 0.85;
  background: #7373FF;
  display: flex;
  align-items: center;
  justify-content: center;

  .icon {
    color: #fff;
  }
}

.screentshots {
  padding: 12px;
  border-radius: 8px;
  background: #F1F0F5;
  flex: 1;

  .screentshots-title {
    color: #0f0629;
    font-family: "Sora";
    font-size: 13px;
    font-style: normal;
    font-weight: 500;

    opacity: 0.7;
  }

  .screentshots-content {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;

    .image-box {
      width: 130px;
      height: 130px;
      border-radius: 8px;
      overflow: hidden;
    
      background-color: #F1F0F5;
    border: 1px solid #E5E5E5;
    border-radius: 8px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
     
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }
}

.content-linkType {
  display: inline-flex;
  width: fit-content;
  padding: 3px 4px;
  align-items: center;
  gap: 6px;
  border-radius: 6px;
  background: #F1F0F5;

  .content-linkType-text {
    font-family: Sora;
    font-weight: 400;
    font-size: 13px;

    letter-spacing: 0.3px;

  }

  .icon {
    width: 20px !important;
    height: 20px !important;
  }
}

.padding-16 {
  padding: 10px 16px 10px 16px;
}

.red-text {
  color: #EB4E3D;
}

.contentFlexOne {
  display: flex;
  gap: 16px;
  margin-top: 16px;
}

.contentFlex {
  display: flex;
  gap: 16px;
  margin-top: 16px;

  .content {
    flex: 1;
  }
}

.daochu1 {
  position: relative;
  top: -1px;
  width: 18px;
  height: 18px;
}

.resources-content-item {
  display: flex;
  gap: 10px;
  align-items: flex-end;
  flex-wrap: wrap;
  .resources-item{
   
   
    .item-content-image{
      background-color: #F1F0F5;
    border: 1px solid #E5E5E5;
    border-radius: 8px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
      width: 40px;
      height: 40px;
      border-radius: 8px;
      overflow: hidden;
   
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
   
  }
}

.product-item {
  display: flex;

  img {
    width: 60px;
    height: 60px;
    margin-right: 10px;
    object-fit: contain;
  }

  .text {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    justify-content: center;


    .title {
      max-width: 100%;
      // white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 2;
      word-break: break-word;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      overflow: hidden;

    }

  }
}

.text-gray {
  font-family: "Sora";
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  padding-left: 6px;
  letter-spacing: 0.4px;
  text-decoration: line-through;
  opacity: 0.7;
}

.commission-tag {
  font-family: "Sora";
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
}

.campaigns {
  padding: 16px;
  padding-top: unset;
  width: 100%;
  position: relative;

  .content-wrapper-bottom {
    padding: 24px 16px;
  }

  .marigin-top-16 {
    margin-top: 16px;
  }

  .content {
    border-radius: 8px;
    background-color: #fff;

    .content-wrapper-top {
      border-bottom: 1px solid #E5E6EB;

      .content-wrapper-top-title-button {
        display: flex;
        justify-content: space-between;
        align-items: center;

      }

      .content-wrapper-top-title {
        font-family: Sora;
        font-weight: 600;
        font-size: 20px;
        padding: 16px;
      }
    }

    .steps-wrapper {
      padding: 16px 20px;
    }

    .content-wrapper-bottom-top {
      display: flex;
      gap: 16px;
      // padding: 16px;
      .content-wrapper-bottom-top-item {
        background: #F1F0F5;
        padding: 10px 12px;
        display: flex;
        border-radius: 8px;
        flex: 1;
        gap: 16px;

        .content-wrapper-bottom-top-item-title {
          color: #0f062980;
          font-family: "Sora";
          font-size: 13px;
          font-style: normal;
          font-weight: 500;

          opacity: 0.7;
        }

        .content-wrapper-bottom-top-item-content {
          color: #0f0629e6;
          font-family: "Sora";
          font-size: 18px;
          font-style: normal;
          font-weight: 600;

        }

        .content-wrapper-bottom-top-item-left {
          flex: 1;

        }

      }

      .item {
        flex: 1;

        .item-title {
          font-family: Sora;
          font-weight: 400;
          font-size: 13px;
          color: #0f0629;
          opacity: 0.5;
        }

        .item-content {
          font-family: Sora;
          font-weight: 500;
          font-style: Medium;
          font-size: 14px;
          margin-top: 4px;

          display: flex;
          gap: 10px;
          flex-wrap: wrap;
          .resources-content {
            display: flex;
            gap: 10px;
          }

        }
      }
    }
  }
}
</style>